/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateOrganisationCommandControllerCreate201,
  CreateOrganisationDto,
  ListOrganisationsQueryControllerListParams,
  ListOrganisationsResponseDto,
  OrganisationResponseDto,
  UpdateOrganisationCommandControllerUpdate200,
  UpdateOrganisationDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a new organisation
 */
export const createOrganisationCommandControllerCreate = (
  createOrganisationDto: CreateOrganisationDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateOrganisationCommandControllerCreate201>({
    url: `/v1/organisations/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOrganisationDto,
    signal,
  });
};

export const getCreateOrganisationCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>,
    TError,
    { data: CreateOrganisationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>,
  TError,
  { data: CreateOrganisationDto },
  TContext
> => {
  const mutationKey = ["createOrganisationCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>,
    { data: CreateOrganisationDto }
  > = (props) => {
    const { data } = props ?? {};

    return createOrganisationCommandControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganisationCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>
  >;
export type CreateOrganisationCommandControllerCreateMutationBody =
  CreateOrganisationDto;
export type CreateOrganisationCommandControllerCreateMutationError = void;

/**
 * @summary Create a new organisation
 */
export const useCreateOrganisationCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>,
      TError,
      { data: CreateOrganisationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganisationCommandControllerCreate>>,
  TError,
  { data: CreateOrganisationDto },
  TContext
> => {
  return useMutation(
    getCreateOrganisationCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Update an organisation
 */
export const updateOrganisationCommandControllerUpdate = (
  slug: string,
  updateOrganisationDto: UpdateOrganisationDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateOrganisationCommandControllerUpdate200>({
    url: `/v1/organisations/${slug}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateOrganisationDto,
    signal,
  });
};

export const getUpdateOrganisationCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>,
    TError,
    { slug: string; data: UpdateOrganisationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>,
  TError,
  { slug: string; data: UpdateOrganisationDto },
  TContext
> => {
  const mutationKey = ["updateOrganisationCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>,
    { slug: string; data: UpdateOrganisationDto }
  > = (props) => {
    const { slug, data } = props ?? {};

    return updateOrganisationCommandControllerUpdate(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganisationCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>
  >;
export type UpdateOrganisationCommandControllerUpdateMutationBody =
  UpdateOrganisationDto;
export type UpdateOrganisationCommandControllerUpdateMutationError = void;

/**
 * @summary Update an organisation
 */
export const useUpdateOrganisationCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>,
      TError,
      { slug: string; data: UpdateOrganisationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganisationCommandControllerUpdate>>,
  TError,
  { slug: string; data: UpdateOrganisationDto },
  TContext
> => {
  return useMutation(
    getUpdateOrganisationCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Delete an organisation
 */
export const deleteOrganisationCommandControllerDelete = (
  slug: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/organisations/${slug}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteOrganisationCommandControllerDeleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>,
    TError,
    { slug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationKey = ["deleteOrganisationCommandControllerDelete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return deleteOrganisationCommandControllerDelete(slug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganisationCommandControllerDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>
  >;

export type DeleteOrganisationCommandControllerDeleteMutationError = void;

/**
 * @summary Delete an organisation
 */
export const useDeleteOrganisationCommandControllerDelete = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>,
      TError,
      { slug: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganisationCommandControllerDelete>>,
  TError,
  { slug: string },
  TContext
> => {
  return useMutation(
    getDeleteOrganisationCommandControllerDeleteMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get an organisation by slug
 */
export const findOrganisationQueryControllerFindBySlug = (
  slug: string,
  signal?: AbortSignal,
) => {
  return axiosClient<OrganisationResponseDto>({
    url: `/v1/organisations/${slug}`,
    method: "GET",
    signal,
  });
};

export const getFindOrganisationQueryControllerFindBySlugQueryKey = (
  slug: string,
) => {
  return [`/v1/organisations/${slug}`] as const;
};

export const getFindOrganisationQueryControllerFindBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFindOrganisationQueryControllerFindBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>
  > = ({ signal }) => findOrganisationQueryControllerFindBySlug(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindOrganisationQueryControllerFindBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>
>;
export type FindOrganisationQueryControllerFindBySlugQueryError = void;

export function useFindOrganisationQueryControllerFindBySlug<
  TData = Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
  TError = void,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
          TError,
          Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindOrganisationQueryControllerFindBySlug<
  TData = Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
          TError,
          Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindOrganisationQueryControllerFindBySlug<
  TData = Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an organisation by slug
 */

export function useFindOrganisationQueryControllerFindBySlug<
  TData = Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findOrganisationQueryControllerFindBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindOrganisationQueryControllerFindBySlugQueryOptions(
    slug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all organisations
 */
export const listOrganisationsQueryControllerList = (
  params?: ListOrganisationsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListOrganisationsResponseDto>({
    url: `/v1/organisations`,
    method: "GET",
    params,
    signal,
  });
};

export const getListOrganisationsQueryControllerListQueryKey = (
  params?: ListOrganisationsQueryControllerListParams,
) => {
  return [`/v1/organisations`, ...(params ? [params] : [])] as const;
};

export const getListOrganisationsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
  TError = void,
>(
  params?: ListOrganisationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganisationsQueryControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>
  > = ({ signal }) => listOrganisationsQueryControllerList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganisationsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>
>;
export type ListOrganisationsQueryControllerListQueryError = void;

export function useListOrganisationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
  TError = void,
>(
  params: undefined | ListOrganisationsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganisationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
  TError = void,
>(
  params?: ListOrganisationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganisationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
  TError = void,
>(
  params?: ListOrganisationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all organisations
 */

export function useListOrganisationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
  TError = void,
>(
  params?: ListOrganisationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganisationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganisationsQueryControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
